export function fixedHeadersAnimated() {
  ScrollTrigger.create({
    trigger: ".bottle-icons-text",
    scroller: "#smooth-wrapper", // important if using smooth scrolling
    start: "top top", // adjust as needed
    // markers: true,
    onEnter: () => {
      document.querySelector("#main_menu_block").style.background = "none";
    },
    onLeaveBack: () => {
      document.querySelector("#main_menu_block").style.background = "url(../../../custom/images/svgs/top-header.webp) center / 100% 100% no-repeat";
    },
  });

  // ScrollTrigger.create({
  //   trigger: ".some-footer-trigger", // use an element close to or above footer
  //   scroller: "#smooth-wrapper",
  //   start: "top -20%", // customize to fit your design
  //   // markers: true,
  //   onEnter: () => {
  //     document.querySelector(".footer-nav--sm").style.background = "none";
  //   },
  //   onLeaveBack: () => {
  //     document.querySelector(".footer-nav--sm").style.background = "url(../../../custom/images/svgs/bottom-header.webp) center / 100% 100% no-repeat";
  //   },
  // });
}
